// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Up_0","icon":"styles_icon__114ow"};